/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ width: NonNullable<unknown>, height: NonNullable<unknown> }} Crosspostingframingexact2Inputs */

const en_crosspostingframingexact2 = /** @type {(inputs: Crosspostingframingexact2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This image already matches the format. Published at ${i?.width} × ${i?.height} px.`)
};

const de_crosspostingframingexact2 = /** @type {(inputs: Crosspostingframingexact2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Bild passt bereits zum Format. Veröffentlicht mit ${i?.width} × ${i?.height} px.`)
};

/**
* | output |
* | --- |
* | "This image already matches the format. Published at {width} × {height} px." |
*
* @param {Crosspostingframingexact2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingframingexact2 = /** @type {((inputs: Crosspostingframingexact2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingframingexact2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingframingexact2(inputs)
	return de_crosspostingframingexact2(inputs)
});
export { crosspostingframingexact2 as "crosspostingFramingExact" }